import { render } from "./ModalSelectPayNowPaymentMethod.vue?vue&type=template&id=0fcb443b&scoped=true"
import script from "./ModalSelectPayNowPaymentMethod.vue?vue&type=script&lang=js"
export * from "./ModalSelectPayNowPaymentMethod.vue?vue&type=script&lang=js"

import "./ModalSelectPayNowPaymentMethod.vue?vue&type=style&index=0&id=0fcb443b&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcb443b"]])

export default __exports__